// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header[data-v-6a2a8b66]{grid-area:header}.thumbnail[data-v-6a2a8b66]{grid-area:thumbnail}.content[data-v-6a2a8b66]{grid-area:content}.links[data-v-6a2a8b66]{grid-area:links}.recommended[data-v-6a2a8b66]{grid-area:recommended}.section-comments[data-v-6a2a8b66]{grid-area:comments}.section .section-actions[data-v-6a2a8b66]{padding-bottom:0!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
